import React, { Component } from 'react';
import { Layout, PageHeader, Divider } from 'antd';
import CommonLayout from '@/components/Documents/common/layout';
import styles from './index.module.less';
const ReactMarkdown = require('react-markdown/with-html');
import markdownSecurity from "./markdown_security";



class SecurityLayout extends Component {

  render(){

    return (
        <Layout.Content className={styles.layoutContent}>
          <PageHeader>
            <div className={styles.content}>
              <div className={styles.markdownContainer}>
                <ReactMarkdown source={markdownSecurity} escapeHtml={false}></ReactMarkdown>
              </div>
            </div>
          </PageHeader>
          <Divider className={styles.line}/>
        </Layout.Content>
    )
  } 
}

export default function() {
  return (
    <CommonLayout tabKey={'security_guard'}>
      <SecurityLayout />
    </CommonLayout>
  )
}
